<div class="aig-contact container u-py-5">
  <div class="o-container">
    <aig-breadcrumb [config]="[
    { title: 'Seguro de Ciberseguridad', link: '/' }
]"></aig-breadcrumb>
    <aig-contact-form></aig-contact-form>
  </div>
</div>
